import { routePaths } from '../../../routePaths';
import { translate } from '../../../utils';
import { RouteType } from '../../../types';
import { WarehousePage } from '../../../modules/warehouse/components';
import { CreateWarehouseForm, UpdateWarehouseForm } from '../../../modules/warehouse/components/WarehouseForm';
import { WarehousePermission } from '../../../generated/graphql';

const WarehouseListRoute: RouteType = {
    exact: false,
    showInSideBar: true,
    path: routePaths.warehouses,
    title: translate('Warehouses'),
    component: WarehousePage,
    childrenRoutes: [
        {
            exact: true,
            title: translate('New warehouse'),
            component: CreateWarehouseForm,
            path: routePaths.warehousesCreate,
            permissions: {
                warehouse: [WarehousePermission.CanAddWarehouse]
            },
            redirectRoute: routePaths.warehouse,
        },
        {
            exact: true,
            title: translate('Update warehouse'),
            component: UpdateWarehouseForm,
            path: routePaths.warehousesUpdate,
            permissions: {
                warehouse: [WarehousePermission.CanUpdateWarehouse]
            },
            redirectRoute: routePaths.warehouse,
        },
    ]
};

export default WarehouseListRoute;
